/** A person as the people column draws them. */
export interface CachedPerson {
  id: number;
  name: string;
  photo_thumb?: string;
}

const people = new Map<number, CachedPerson>();

/**
 * People already looked up in this session, so a people column can redraw at once after an
 * edit instead of waiting a second or two for monday. Filled by the column and the people picker.
 */
export const rememberPeople = (
  list: { id: number | string; name: string; photo_thumb?: string }[],
) => list.forEach((person) => people.set(Number(person.id), { ...person, id: Number(person.id) }));

/** Everyone in `ids`, in order, or null if any of them hasn't been seen yet. */
export const cachedPeople = (ids: (number | string)[]): CachedPerson[] | null => {
  const found = ids.map((id) => people.get(Number(id)));
  return found.every(Boolean) ? (found as CachedPerson[]) : null;
};

/** Empties the cache; for tests. */
export const forgetPeople = () => people.clear();
